import React from "react";
import "./Home.css";

// Import images
import project1 from "../assets/images/project1.jpeg";
import project2 from "../assets/images/project2.jpeg";
import project3 from "../assets/images/project3.jpeg";
import project4 from "../assets/images/project9.jpeg";
import aboutUsImage from "../assets/images/about-image.jpeg";
import truckImage from "../assets/images/IMG_8663.jpg";
import logo from "../assets/images/logo3.png";

// New images to add
import img9741 from "../assets/images/IMG_9741.jpg";
import img9743 from "../assets/images/IMG_9743.jpg";
import img9744 from "../assets/images/IMG_9744.jpg";
import img9747 from "../assets/images/IMG_9747.jpg";

import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhone } from "@fortawesome/free-solid-svg-icons";
import Contact from "./Contact";
import WhyUs from "./WhyUs";

const Home = () => {
  return (
    <div className="home-container">
      {/* Top Black Banner */}
      <div className="top-banner">
        <p>
          <FontAwesomeIcon icon={faPhone} /> Main:{" "}
          <a href="tel:2405842751">240-584-2751</a> | Cell:{" "}
          <a href="tel:2406949984">240-694-9984</a>
        </p>
      </div>

      {/* Hero Section */}
      <div className="hero-section">
        <div className="hero-overlay">
          <h1>Welcome to KOA Electric</h1>
          <p>Reliable Commercial & Residential Electrical Services</p>
          <a href="/services" className="btn btn-warning">
            Our Services
          </a>
        </div>
      </div>

      {/* About Section */}
      <section className="about-section my-5 text-center">
        <h2>About KOA Electric</h2>
        <div className="container">
          <div className="row">
            <div className="col-md-6 d-flex flex-column align-items-center">
              <img src={aboutUsImage} alt="KOA Electric Team" className="img-fluid rounded mb-3" />
              <img src={logo} alt="KOA Electric Logo" className="img-fluid logo-img" style={{ maxWidth: "450px" }} />
            </div>

            <div className="col-md-6 text-start">
              <p>
                KOA Electric has been providing top-quality electrical services to both commercial and residential clients for over 10 years...
              </p>
              <h3>Our Mission</h3>
              <p>
                Our mission is to deliver exceptional electrical services that ensure safety and reliability for our clients...
              </p>
              <h3>Our Values</h3>
              <ul className="list-unstyled">
                <li>Integrity: We uphold the highest standards of honesty and transparency.</li>
                <li>Quality: Delivering services that stand the test of time.</li>
                <li>Customer Focus: Meeting our clients’ needs first.</li>
                <li>Innovation: Staying updated with the latest electrical tech.</li>
              </ul>
              <h3>Meet Our Team</h3>
              <p>Our licensed electricians are passionate about their craft...</p>
              <h3>Why Choose Us?</h3>
              <p>
                - <strong>Experienced Professionals:</strong> With a decade of experience...<br />
                - <strong>24/7 Emergency Services:</strong> Round-the-clock help...<br />
                - <strong>Customer Satisfaction Guarantee:</strong> We stand by our work.
              </p>
              <a href="/about" className="btn btn-warning">Learn More</a>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="services-section my-5 text-center">
        <h2>Our Services</h2>
        <div className="row">
          <div className="col-lg-4 col-md-6 mb-4">
            <div className="service-item border rounded p-3">
              <h3>Residential Services</h3>
              <p>We handle wiring, lighting, panel upgrades, and more.</p>
            </div>
          </div>
          <div className="col-lg-4 col-md-6 mb-4">
            <div className="service-item border rounded p-3">
              <h3>Commercial Services</h3>
              <p>Electrical solutions for offices, warehouses, and retail stores.</p>
            </div>
          </div>
          <div className="col-lg-4 col-md-6 mb-4">
            <div className="service-item border rounded p-3">
              <h3>Emergency Services</h3>
              <p>Available 24/7 for urgent electrical issues.</p>
            </div>
          </div>
        </div>
        <a href="/services" className="btn btn-warning">Explore Services</a>
      </section>

      {/* Call Us Section */}
      <section
        className="call-us-section my-5"
        style={{
          backgroundImage: `url(${truckImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          height: "600px",
          padding: "50px 20px",
          backgroundRepeat: "no-repeat",
          margin: "0 auto",
        }}
      >
        <div className="container h-100">
          <div className="row h-100">
            <div className="col-md-6 offset-md-6 d-flex align-items-center">
              <div
                className="text-container"
                style={{
                  backgroundColor: "rgba(128, 128, 128, 0.7)",
                  padding: "20px",
                  borderRadius: "8px",
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  color: "white",
                }}
              >
                <h2 style={{ fontFamily: "Anton, sans-serif", fontSize: "4.5rem", fontWeight: "bold" }}>
                  CALL US TODAY!
                </h2>
                <p
                  style={{
                    fontFamily: "Anton, sans-serif",
                    fontSize: "2.5rem",
                    fontWeight: "bold",
                    textShadow: "2px 2px 4px rgba(0,0,0,0.5)",
                  }}
                >
                  <a href="tel:2405842751" style={{ color: "gold", textDecoration: "none" }}>
                    240-584-2751
                  </a>
                </p>
                <h2>koaelectric66@gmail.com</h2>
                <p>If you have any electrical needs or emergencies, don’t hesitate to reach out to us.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

    {/* NEW Image Gallery Section */}
<section className="image-gallery my-5 text-center px-3">
  <h2 className="mb-3">The New Look of KOA Electric</h2>
  <p className="text-muted mb-4 mx-auto" style={{ maxWidth: "700px" }}>
    We’re proud to showcase our refreshed company branding, now rolling out on our fleet of service vehicles.
    The new KOA Electric logo represents our continued commitment to innovation, reliability, and excellence
    in every project we power. Keep an eye out for our updated vehicles around town — a symbol of our bright future.
  </p>

  <div className="container">
    <div className="row justify-content-center">
      {[img9741, img9743, img9744, img9747].map((img, index) => (
        <div className="col-12 col-sm-6 col-md-6 col-lg-3 mb-4" key={index}>
          <img
            src={img}
            alt={`KOA Electric Vehicle ${index + 1}`}
            className="img-fluid rounded shadow-sm w-100"
            style={{
              height: "auto",
              maxHeight: "250px",
              objectFit: "cover",
              borderRadius: "12px",
            }}
          />
        </div>
      ))}
    </div>
  </div>
</section>



      {/* Testimonials Section */}
      <section className="testimonials-section my-5">
        <h2 className="text-center">What Our Clients Say</h2>
        <div className="testimonial-item text-center">
          <p>"KOA Electric provided excellent service! They were quick and efficient."</p>
          <h5>- Sarah J.</h5>
        </div>
        <div className="testimonial-item text-center">
          <p>"Professional and friendly staff! Highly recommend."</p>
          <h5>- Mike T.</h5>
        </div>
        <div className="testimonial-item text-center">
          <p>"KOA Electric handled our commercial project with care and precision."</p>
          <h5>- Lisa K.</h5>
        </div>
      </section>

      {/* Portfolio Section */}
      <section className="portfolio-section my-5 text-center">
        <h2>Our Portfolio</h2>
        <p>
          Take a look at some of our recent projects that showcase our expertise
          and commitment to quality.
        </p>
        <div className="container">
          <div className="portfolio-scroll">
            <div className="portfolio-item">
              <img
                src={project2}
                alt="Project 1"
                className="img-fluid rounded"
              />
              <h3>Project 1: Residential Wiring Upgrade</h3>
              <p>
                Successfully upgraded the electrical wiring of a historic home,
                enhancing safety and efficiency while preserving the building's
                charm. The project included installing modern circuit breakers
                and energy-efficient lighting solutions to reduce energy costs.
              </p>
            </div>
            <div className="portfolio-item">
              <img
                src={project1}
                alt="Project 2"
                className="img-fluid rounded"
              />
              <h3>Project 2: Commercial Lighting Installation</h3>
              <p>
                Designed and implemented a comprehensive lighting system for a
                local retail store. The project involved installing
                energy-efficient LED fixtures to create a welcoming atmosphere
                while maximizing product visibility and reducing energy
                consumption.
              </p>
            </div>
            <div className="portfolio-item">
              <img
                src={project3}
                alt="Project 3"
                className="img-fluid rounded"
              />
              <h3>Project 3: EV Car Charger Installation</h3>
              <p>
                Led the installation of an EV car charger system for a
                residential client, significantly enhancing their vehicle
                charging convenience and reducing dependency on public charging
                stations. This project included system design, installation, and
                post-installation monitoring to ensure optimal performance and
                client satisfaction.
              </p>
            </div>
            <div className="portfolio-item">
              <img
                src={project4}
                alt="Project 3"
                className="img-fluid rounded"
              />
              <h3>Project 4: Electrical Power Distribution System Installation</h3>
              <p>
              This project involves the installation of an electrical power 
              distribution system within an industrial facility. The image 
              showcases a newly installed transformer and associated electrical 
              panel. Heavy-duty conduit runs are used to route power safely to the 
              transformer and other equipment.
              </p>
            </div>
          </div>

          {/* See More Button */}
          <div className="mt-4">
            <Link to="/portfolio" className="btn btn-gradient">
              View More Projects
            </Link>
          </div>
        </div>
      </section>

      {/* Contact Us Section */}
          <Contact />        
      {/* Whyus */}
      <WhyUs />
    </div>
  );
};

export default Home;

